import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
/**
 * @hidden
 */

var PagerNumericButtonsVue2 = {
  name: 'KendoNumericButtons',
  props: {
    buttonCount: Number,
    totalPages: Number,
    currentPage: Number,
    size: String
  },
  computed: {
    start: {
      get: function get() {
        var page = this.$props.currentPage;
        var buttonCount = this.$props.buttonCount;

        if (page > buttonCount) {
          var reminder = page % buttonCount;
          return reminder === 0 ? page - buttonCount + 1 : page - reminder + 1;
        }

        return 1;
      }
    },
    end: {
      get: function get() {
        return Math.min(this.start + this.$props.buttonCount - 1, this.$props.totalPages);
      }
    }
  },
  methods: {
    click: function click(e, page) {
      e.preventDefault();
      this.$emit('pagechange', page, e);
    },
    ddlChange: function ddlChange(event) {
      this.$emit('pagechange', parseInt(event.target.value, 10), event);
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var prevDots = this.start > 1 ? h("li", [h("a", {
      "class": "k-link",
      onClick: function onClick(e) {
        return _this.click(e, _this.start - 1);
      },
      on: this.v3 ? undefined : {
        "click": function onClick(e) {
          return _this.click(e, _this.start - 1);
        }
      },
      href: "#",
      attrs: this.v3 ? undefined : {
        href: "#"
      }
    }, ["..."])]) : '';
    var postDots = this.end < this.$props.totalPages ? h("li", [h("a", {
      "class": "k-link",
      onClick: function onClick(e) {
        return _this.click(e, _this.end + 1);
      },
      on: this.v3 ? undefined : {
        "click": function onClick(e) {
          return _this.click(e, _this.end + 1);
        }
      },
      href: "#",
      attrs: this.v3 ? undefined : {
        href: "#"
      }
    }, ["..."])]) : '';
    var buttons = [];

    for (var idx = this.start; idx <= this.end; idx++) {
      buttons.push(idx);
    }

    var numerics = buttons.map(function (page) {
      var _this = this;

      return h("li", {
        key: page
      }, [h("a", {
        href: "#",
        attrs: this.v3 ? undefined : {
          href: "#"
        },
        onClick: function onClick(e) {
          return _this.click(e, page);
        },
        on: this.v3 ? undefined : {
          "click": function onClick(e) {
            return _this.click(e, page);
          }
        },
        "class": this.$props.currentPage === page ? 'k-link k-selected' : 'k-link'
      }, [page])]);
    }, this);

    var dropdown = function dropdown(currentButtons) {
      return h("select", {
        "class": "k-dropdownlist k-picker k-picker-md k-rounded-md k-picker-solid",
        onChange: this.ddlChange,
        on: this.v3 ? undefined : {
          "change": this.ddlChange
        }
      }, [currentButtons.map(function (cb) {
        return h("option", {
          value: this.v3 ? cb : null,
          domProps: this.v3 ? undefined : {
            "value": cb,
            "selected": cb === this.$props.currentPage
          },
          selected: this.v3 ? cb === this.$props.currentPage : null
        }, [cb]);
      }, this)]);
    };

    return h("div", {
      "class": "k-pager-numbers-wrap"
    }, [this.$props.size !== 'small' ? h("ul", {
      "class": "k-pager-numbers"
    }, [prevDots, numerics, postDots]) : dropdown.call(this, buttons)]);
  }
};
/**
 * @hidden
 */

var PagerNumericButtons = PagerNumericButtonsVue2;
export { PagerNumericButtons, PagerNumericButtonsVue2 };